"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateSrcSet = void 0;
/**
 * Function generates srcSets based on passed array of Images.
 * @param images
 * @returns srcSet string
 */
const generateSrcSet = images => images.map(variant => `${variant.url} ${variant.width}w`).join(',');
exports.generateSrcSet = generateSrcSet;
//# sourceMappingURL=generateSrcSet.js.map